import { render, staticRenderFns } from "./TaskFocusDetails.vue?vue&type=template&id=15f43373&scoped=true&"
import script from "./TaskFocusDetails.vue?vue&type=script&lang=js&"
export * from "./TaskFocusDetails.vue?vue&type=script&lang=js&"
import style0 from "./TaskFocusDetails.vue?vue&type=style&index=0&id=15f43373&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f43373",
  null
  
)

export default component.exports